<template>
    <div>
        <section class="section hero-section bg-ico-home-1 p-3" style="height: 150px;">
        </section>
        <section class="section bg-white">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-12 col-lg-6">
                        <div data-aos="fade-right">
                            <img src="awan/images/docs-icon.svg" alt="panduan-lengkap-produk-ppob-awanbisnis" class="img-fluid mx-auto d-block">
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div class="mt-4 mt-md-auto">
                            <h1 class="text-center font-weight-bold mb-3 hero-title" data-aos="fade-up"
                                style="font-family: 'Baloo Paaji'; color: #233dff">Panduan lengkap produk PPOB Awanbisnis</h1>
                            <br>
                            <p class="font-size-16 text-center" data-aos="fade-left">AWAN menyediakan dokumentasi yang sangat lengkap dan mudah dipahami untuk memudahkan penggunaan produk PPOB Awanbisnis</p>
                            <br>
                            <div class="mt-2 text-center" data-aos="fade-right">
                                    <a href="https://docs.awanbisnis.com/" class="btn btn-primary" style="background: #233dff">Pelajari lebih lanjut</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>
<script>
export default {
    name: 'Panduan',
    components: {
    },
    data() {
        return {
        }
    },
    methods: {
    },
    mounted() {
        document.title = 'Panduan Lengkap Produk PPOB Di Awanbisnis'
        this.$Progress.start()
        AOS.init({
            easing: 'ease-out-back',
            duration: 2000,
        });
        this.$Progress.finish()
    },
}
</script>